import { render, staticRenderFns } from "./video-compress-mobile.vue?vue&type=template&id=2a436dd8&scoped=true&"
import script from "./video-compress-mobile.vue?vue&type=script&lang=js&"
export * from "./video-compress-mobile.vue?vue&type=script&lang=js&"
import style0 from "./video-compress-mobile.vue?vue&type=style&index=0&id=2a436dd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a436dd8",
  null
  
)

export default component.exports